import React from 'react'
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { useLocale } from '../../hooks/useLocale';
import './style.scss'

export const DragAndDropUpload = ({...props}) => {
  return (
    <div>
        <DropzoneAreaBase
              fileObjects={props?.filesUploaded} 
              dropzoneText={useLocale('draganddrop')}
              dropzoneClass='draganddrop_gtc_controls'
              previewGridProps={{
                  container: {
                      spacing: 1,
                      direction: 'row'
                  }
              }}
              {...props}        />
    </div>
  )
}
